export default __webpack_public_path__ + "assets/images/maxImage-4854f40cce86cb81fd458233c1b0effa.png";